"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PartnerIndustry;
(function (PartnerIndustry) {
    PartnerIndustry["SearchEngineMarketing"] = "SEM";
    PartnerIndustry["SocialMediaMarketing"] = "SMM";
    PartnerIndustry["Ecommerce"] = "Ecommerce";
    PartnerIndustry["DataAndAnalytics"] = "DA";
    PartnerIndustry["DataScience"] = "DS";
    PartnerIndustry["CustomerExperience"] = "CE";
    PartnerIndustry["BusinessConsultancy"] = "BC";
    PartnerIndustry["UserExperience"] = "UX";
    PartnerIndustry["CreativeServices"] = "CS";
    PartnerIndustry["ContentManagement"] = "CM";
    PartnerIndustry["Development"] = "DEV";
    PartnerIndustry["SearchEngineOptimisation"] = "SEO";
    PartnerIndustry["Strategy"] = "Strategy";
})(PartnerIndustry = exports.PartnerIndustry || (exports.PartnerIndustry = {}));
//# sourceMappingURL=partner.industry.js.map